import { AuditTrailReportTable } from './AuditTrailReportTable';

export default AuditTrailReportTable;
